import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "../../interface/redux.interface";
import { User } from "../../interface/user.interface";
import { useWindowBreakpoints } from "../../custom-hooks/useWindowBreakpoints";
import { routes } from "../../gen/General";
import { getRandomF } from "../../util/General";

interface ProdesegUserImageProps extends React.ComponentProps<"img"> {
    isSmall?: boolean;
}

export const ProdesegUserImage: React.FC<ProdesegUserImageProps> = ({ isSmall = false, ...props }) => {
    const user = useSelector<ReduxState, User>(state => state.user);
    const { isDownSm } = useWindowBreakpoints();

    const getIconSize = useCallback(() => {
        if (!isSmall) return "96px";
        return isDownSm ? "34px" : "40px";
    }, [isDownSm]);

    return (
        <div
            className={`rounded-circle overflow-hidden shadow-${isSmall ? "sm" : "lg"}`}
            style={{
                border: `${isSmall ? "1" : "2"}px solid white`,
                aspectRatio: "1/1",
                height: getIconSize(),
            }}
        >
            <img
                {...props}
                className={"h-100 w-auto"}
                src={routes.api + "/user/img/" + user.id + "?vrd=" + getRandomF()}
                alt="Perfil del usuario"
                style={{
                    objectPosition: "center",
                    objectFit: "cover",
                }}
            />
        </div>
    );
};
